import { render, staticRenderFns } from "./functionaly.vue?vue&type=template&id=13b4fcc8&scoped=true"
import script from "./functionaly.vue?vue&type=script&lang=js"
export * from "./functionaly.vue?vue&type=script&lang=js"
import style0 from "./functionaly.vue?vue&type=style&index=0&id=13b4fcc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4fcc8",
  null
  
)

export default component.exports